export default "__VITE_ASSET__CXghqy22__"